module.exports = __webpack_public_path__ + "img/xl_anhui.f77b38fa.png";